import * as React from "react";

const Phone = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2302 10.455C14.7028 10.455 14.2752 10.8826 14.2752 11.41V28.59C14.2752 29.1174 14.7028 29.545 15.2302 29.545H24.7702C25.2977 29.545 25.7252 29.1174 25.7252 28.59V11.41C25.7252 10.8826 25.2977 10.455 24.7702 10.455H15.2302ZM12.3652 11.41C12.3652 9.82769 13.6479 8.54498 15.2302 8.54498H24.7702C26.3525 8.54498 27.6352 9.82769 27.6352 11.41V28.59C27.6352 30.1723 26.3525 31.455 24.7702 31.455H15.2302C13.6479 31.455 12.3652 30.1723 12.3652 28.59V11.41Z"
      fill="#020202"
      stroke="black"
      strokeWidth="0.5"
      strokeMiterlimit="10"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.6803 26.635H13.3203V24.725H26.6803V26.635Z"
      fill="#020202"
      stroke="black"
      strokeWidth="0.25"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Phone;
